import {Basic} from "./Basic";

export class AnnouncementSlides
{
    constructor(slides)
    {
        AnnouncementSlides.slides = slides;
        AnnouncementSlides.activeSlideNo = 0;
        Basic.insert_switchControls(document.getElementById('w--bg'),'announcement-switch');
        AnnouncementSlides.set_controlColorClass();
    }

    static set_controlColorClass()
    {
        const controls = document.getElementById('w--bg').querySelector('.w__controls');
        if(controls)
        {
            if(AnnouncementSlides.slides[AnnouncementSlides.activeSlideNo].querySelector('.mod--black'))
            {
                controls.classList.add('mod--black');
            }
            else
            {
                controls.classList.remove('mod--black');
            }
        }
    }

    static switch(el)
    {
        let newSlideNo;

        if(el.classList.contains('mod--prev'))
        {
            newSlideNo = AnnouncementSlides.activeSlideNo - 1;
        }
        else
        {
            newSlideNo = AnnouncementSlides.activeSlideNo + 1;
        }

        if(newSlideNo < 0)
        {
            newSlideNo = AnnouncementSlides.slides.length - 1;
        }
        else if(newSlideNo > AnnouncementSlides.slides.length - 1)
        {
            newSlideNo = 0;
        }

        const loadImage = AnnouncementSlides.slides[newSlideNo].querySelector('.w__bg--image.mod--load');
        if(loadImage)
        {
            // add waiting cursor
            document.documentElement.classList.add('w__waiting');
            loadImage.classList.remove('mod--load');

            // create image
            const src = Basic.adjust_imagePath(loadImage.href),
                  myImage = new Image;
            myImage.className = loadImage.className;
            myImage.src = src;
            myImage.alt = loadImage.textContent;

            myImage.addEventListener('load',() =>
            {
                // remove waiting cursor
                document.documentElement.classList.remove('w__waiting');
                loadImage.insertAdjacentElement('afterend', myImage)
                loadImage.remove();
                AnnouncementSlides.switchNow(newSlideNo);
            });
        }
        else
        {
            AnnouncementSlides.switchNow(newSlideNo);
        }
    }

    static switchNow(newSlideNo)
    {
        AnnouncementSlides.slides[AnnouncementSlides.activeSlideNo].classList.remove('active');
        AnnouncementSlides.slides[newSlideNo].classList.add('active');
        AnnouncementSlides.activeSlideNo = newSlideNo;
        AnnouncementSlides.set_controlColorClass();
    }
}